import React, {useEffect, useMemo, useState} from 'react';
import { Form, Input, DatePicker, InputNumber } from 'antd';
import SPSelectWithApi from "../../../../../../components/product-price/base/SPSelectWithApi";
import OrderDeductionModal from "../index";
import SPSelectWithEnum from "../../../../../../components/product-price/base/SPSelectWithEnum";
import SPUploadPhotos from "../../../../../../components/base/SPUploadPhotos";
import {API_VEHICLE_UPLOAD_PHOTO} from "../../../../../../hooks/carRental/_";
const { TextArea } = Input;

interface IComponentProps {
  data?: any;
    enums?: any
}
const ThawDeposi: React.FC<IComponentProps> = (props) => {
  const data = props.data;
  const { enums } = props
    const form = Form.useFormInstance()
    const mainFormFields = {
        cheliangwaiguantupian: {
            name: ''
        }
    }

    const onChange = (type: any) => {
      let amount = null
        if (type === 1) {
            amount = data?.bill?.deposit?.broken_remain_amount / 100
        } else if (type === 2) {
            amount = data?.bill?.deposit?.ill_all_remain_amount / 100
        } else if (type === 3) {
            amount = data?.bill?.deposit?.remain_amount / 100
        }
        form.setFieldsValue({
            amount: amount,
        })
    }

    return (
    <>
    <Form.Item label={'解冻类型'} name={'unfreeze_type'} rules={[{required: true, message: '请选择解冻类型'}]}>
        <SPSelectWithEnum
            onChange={onChange}
            placeholder={'请选择解冻类型'}
            enums={enums}
            enumKey={'deposit_unfreeze_type'}>
        </SPSelectWithEnum>
    </Form.Item>
        <Form.Item name={'amount'}  label={'解冻金额'} rules={[{required: true }]}>
           <InputNumber disabled={true} style={{width: '100%'}} ></InputNumber>
        </Form.Item>
        <Form.Item label={'解冻原因'} name={'reason'} rules={[{required: true, message: '请选择解冻原因'}]}>
            <SPSelectWithEnum
                onlyLabel={true}
                placeholder={'请选择解冻原因'}
                enums={enums}
                enumKey={'f_thawing_cause'}>
            </SPSelectWithEnum>
        </Form.Item>
    </>
  );
};

export default ThawDeposi;
